import React, { useState, useEffect, useContext } from "react";
import Button from "../../../components/_default/Button";
import DefineMedia from "../../../components/_default/DefineMedia";
import Input from "../../../components/_default/Input";
import Popup from "../../../components/_default/Popup";

import "./DefineMealplan.scss";
import Plans from "../../../components/_mealplans/Plans";
import generateUnique from "../../../services/defaultFunctions/generateUnique";
import { updateMealplanAurum, updateMealplanCoach } from "../../../services/firebase/firestore/updateData";
import { addMealplanAurum, addMealplanCoach } from "../../../services/firebase/firestore/saveData";
import { deleteMediaArrayFromStorage } from "../../../services/firebase/storage";
import isIterable from "../../../services/defaultFunctions/isIterable";
import UserContext from "../../../services/context/userContext";
import Header from '../../../components/_default/Header'
import Textarea from "../../../components/_default/Textarea";

function DefineMealplan({ ...props }) {
  const categories = ["Sort by name", "Sort by date", "test"];
  const [category, setCategory] = useState(categories[0]);
  const [image, setImage] = useState(false);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [error, setError] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [update, setUpdate] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingDuplicate, setLoadingDuplicate] = useState(false);
  const [deleteUrlArray, setDeleteUrlArray] = useState(false);
  const [totalCalories, setTotalCalories] = useState({
    protein: 0, fats: 0, carbs: 0, alcohol: 0, fiber: 0, calories: 0
  });

  const [plan, set_plan] = useState([
    {
      food: [
        {
          mealplan_id: "vrzcIWv3OKOdd3dIbyQ0mr83",
          name: "",
          protein: 0,
          fats: 0,
          carbs: 0,
          alcohol: 0,
          fiber: 0,
          calories: 0,
          quantity: 100,
          eaten: false,
          thumbnail: ""
        },
      ],
      id: "8796-8897a",
      name: "",
    },
  ]);

  const user = useContext(UserContext);
  const from = props.location.state.from;
  const isAdmin = !(from === "aurum" && !user.admin && props?.location?.state?.update);
  // const isAdmin = !((from === "aurum"||from=="coach") && !user.admin && props?.location?.state?.update);
  // const isAdmin = !((from === "aurum"||from=="coach") && !user.admin && props?.location?.state?.update);

  useEffect(() => {
    let _mealplan = props.location.state.item;
    if (props.location.state.update || props.location.state.copy) {
      setCategory(_mealplan.category);
      setImage(_mealplan.image);
      setName(_mealplan.name);
      setDescription(_mealplan.description);
      set_plan(_mealplan.plan);
      setLoadingDuplicate(false);
      window.scrollTo({top: 0, behavior: 'smooth'});
    }
    setUpdate(props.location.state.update);
  }, [props.location.state]);


  useEffect(() => {
    let _calories = { protein: 0, fats: 0, carbs: 0, alcohol: 0, fiber: 0, calories: 0 };
    plan.forEach(food => {
      food.food.forEach(nutrient => { 
        _calories.protein = _calories.protein+parseFloat(nutrient.protein);
        _calories.fats = _calories.fats+parseFloat(nutrient.fats);
        _calories.carbs = _calories.carbs+parseFloat(nutrient.carbs);
        _calories.alcohol = _calories.alcohol+parseFloat(nutrient.alcohol);
        _calories.fiber = _calories.fiber+parseFloat(nutrient.fiber);
        _calories.calories = _calories.calories+parseFloat(nutrient.calories);
      });
    });
    setTotalCalories(_calories);
  }, [plan])

  const addToDeleteUrl = (pageType, url) => {
    let _deleteUrlArray = isIterable(deleteUrlArray) ? [...deleteUrlArray] : [];
    _deleteUrlArray.push(url);
    setDeleteUrlArray(_deleteUrlArray);
  };

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);

    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const reorderChild = (list, start, end) => {
    const result = Array.from(list);

    const parent_start_index = result.findIndex((e) => e.id === start.droppableId);
    const parent_end_index = result.findIndex((e) => e.id === end.droppableId);
    const [removed] = result[parent_start_index].food.splice(start.index, 1);
    result[parent_end_index].food.splice(end.index, 0, removed);

    return result;
  };

  function onDragEnd(result) {
    const { destination, source, type, draggableId } = result;
    let new_plan = plan;

    if (!result.destination) {
      return;
    }
    switch (type) {
      case "parent":
        new_plan = reorder(plan, source.index, destination.index);
        break;
      case "child":
        new_plan = reorderChild(plan, source, destination);
        break;
      default:
        break;
    }
    set_plan(new_plan);
  }

  function addSet() {
    let _plan = [...plan];
    _plan.push({
      food: [
        {
          mealplan_id: generateUnique(1, 9),
          name: "",
          protein: 0,
          fats: 0,
          carbs: 0,
          alcohol: 0,
          fiber: 0,
          calories: 0,
          quantity: 100,
          eaten: false,
          thumbnail: ""
        },
      ],
      id: generateUnique(1, 9),
      name: "",
      rest_time_in_minutes: 0,
    });
    set_plan(_plan);
  }

  function removeSet(set_idx) {
    let _plan = [...plan];
    switch (showPopup.type) {
      case "set":
        _plan.splice(set_idx, 1);
        break;
      case "mealplan":
        _plan[showPopup.set_idx].food.splice(showPopup.mealplan_idx, 1);
        break;

      default:
        break;
    }

    set_plan(_plan);
    setShowPopup(false);
  }

  function addFood(idx) {
    let _plan = [...plan];
    _plan[idx].food.push({
      mealplan_id: generateUnique(1, 9),
      name: "",
      protein: 0,
      fats: 0,
      carbs: 0,
      alcohol: 0,
      fiber: 0,
      calories: 0,
      quantity: 100,
      eaten: false,
      thumbnail: ""
    });

    set_plan(_plan);
  }

  function onChange(e, type, food_idx, set_idx) {
    
    let _plan = [...plan];

    if (type === "quantity") {
      _plan[set_idx].food[food_idx].add_food = false;
      _plan[set_idx].food[food_idx].protein = parseFloat((_plan[set_idx].food[food_idx].protein / _plan[set_idx].food[food_idx].quantity) * parseFloat(e > 0 ? e : 1)).toFixed(2);
      _plan[set_idx].food[food_idx].fats = parseFloat((_plan[set_idx].food[food_idx].fats / _plan[set_idx].food[food_idx].quantity) * parseFloat(e > 0 ? e : 1)).toFixed(2);
      _plan[set_idx].food[food_idx].carbs = parseFloat((_plan[set_idx].food[food_idx].carbs / _plan[set_idx].food[food_idx].quantity) * parseFloat(e > 0 ? e : 1)).toFixed(2);
      _plan[set_idx].food[food_idx].alcohol = parseFloat((_plan[set_idx].food[food_idx].alcohol / _plan[set_idx].food[food_idx].quantity) * parseFloat(e > 0 ? e : 1)).toFixed(2);
      _plan[set_idx].food[food_idx].fiber = parseFloat((_plan[set_idx].food[food_idx].fiber / _plan[set_idx].food[food_idx].quantity) * parseFloat(e > 0 ? e : 1)).toFixed(2);
      _plan[set_idx].food[food_idx].calories = parseFloat((_plan[set_idx].food[food_idx].calories / _plan[set_idx].food[food_idx].quantity) * parseFloat(e > 0 ? e : 1)).toFixed(2);
      _plan[set_idx].food[food_idx][type] = e > 0 ? e : 1;
    } else {
      if (food_idx !== false) {
        _plan[set_idx].food[food_idx][type] = e;
      } else {
        _plan[set_idx][type] = e;
      }
    }
    if (type === "add_food") {
      // fetch(`https://api.spoonacular.com/recipes/${e.id}/nutritionWidget.json?apiKey=f29bf8a6bd9b40ef8ed2b568fdff9775`)
      //   .then(response => response.json())
      //   .then(data => {
      //     console.log(data);
          // _plan[set_idx].food[food_idx].name = e.title;
          // _plan[set_idx].food[food_idx].protein = parseFloat(parseFloat(data.protein) ? (parseFloat(data.protein) / 100) * _plan[set_idx].food[food_idx].quantity : 0).toFixed(2);
          // _plan[set_idx].food[food_idx].fats = parseFloat(parseFloat(data.fat) ? (parseFloat(data.fat) / 100) * _plan[set_idx].food[food_idx].quantity : 0).toFixed(2);
          // _plan[set_idx].food[food_idx].carbs = parseFloat(parseFloat(data.carbs) ? (parseFloat(data.carbs) / 100) * _plan[set_idx].food[food_idx].quantity : 0).toFixed(2);
          // //_plan[set_idx].food[food_idx].alcohol = parseFloat(parseFloat(data.bad)[7].amount ? (parseFloat(data.bad)[7].amount / 100) * _plan[set_idx].food[food_idx].quantity : 0).toFixed(2);
          // //_plan[set_idx].food[food_idx].fiber = parseFloat(parseFloat(data.good)[20].amount ? (parseFloat(data.good)[20].amount / 100) * _plan[set_idx].food[food_idx].quantity : 0).toFixed(2);
          // _plan[set_idx].food[food_idx].calories = parseFloat(parseFloat(data.calories) ? (parseFloat(data.calories) / 100) * _plan[set_idx].food[food_idx].quantity : 0).toFixed(2);
          // _plan[set_idx].food[food_idx].thumbnail = e.image;
          // set_plan(_plan);
        //});
      }

    if (type === "add_food") {
      _plan[set_idx].food[food_idx].name = e.product_name;
      _plan[set_idx].food[food_idx].add_food = false;
      _plan[set_idx].food[food_idx].protein = parseFloat(e.nutriments.proteins_100g ? (e.nutriments.proteins_100g / 100) * _plan[set_idx].food[food_idx].quantity : 0).toFixed(2);
      _plan[set_idx].food[food_idx].fats = parseFloat(e.nutriments.fat_100g ? (e.nutriments.fat_100g / 100) * _plan[set_idx].food[food_idx].quantity : 0).toFixed(2);
      _plan[set_idx].food[food_idx].carbs = parseFloat(e.nutriments.carbohydrates_100g ? (e.nutriments.carbohydrates_100g / 100) * _plan[set_idx].food[food_idx].quantity : 0).toFixed(2);
      _plan[set_idx].food[food_idx].alcohol = parseFloat(e.nutriments.alcohol_100g ? (e.nutriments.alcohol_100g / 100) * _plan[set_idx].food[food_idx].quantity : 0).toFixed(2);
      _plan[set_idx].food[food_idx].fiber = parseFloat(e.nutriments.fiber_100g ? (e.nutriments.fiber_100g / 100) * _plan[set_idx].food[food_idx].quantity : 0).toFixed(2);
      _plan[set_idx].food[food_idx].calories = parseFloat(e.nutriments["energy-kcal_100g"] ? (e.nutriments["energy-kcal_100g"] / 100) * _plan[set_idx].food[food_idx].quantity : 0).toFixed(2);
      _plan[set_idx].food[food_idx].thumbnail = e.image_front_thumb_url;
    }
    if(_plan[set_idx].food[food_idx]){
      _plan[set_idx].food[food_idx].add_food = {};
    }
    
    set_plan(_plan);
  }

  function initiateLoading(type, value) {
    if (type === "duplicate") {
      setLoadingDuplicate(value);
    } else {
      setLoading(value);
    }
  }

  function onSubmit(duplicate) {
    let _empty_plan_name = plan.findIndex((e) => e.name === "");
    let _empty_food_in_plan = plan.findIndex((e) => e.food.length <= 0);
    initiateLoading(duplicate ? "duplicate" : "save", true);
    if (name === "") {
      initiateLoading(duplicate ? "duplicate" : "save", false);
      setError({ type: "name", message: "Add a name for your mealplan." });
    } else if (description === "") {
      initiateLoading(duplicate ? "duplicate" : "save", false);
      setError({ type: "description", message: "Add a short description for your mealplan." });
    } else if (_empty_plan_name >= 0) {
      initiateLoading(duplicate ? "duplicate" : "save", false);
      setError({ type: "plan_name", message: "Add a name for your meal.", idx: _empty_plan_name });
    } else if (_empty_food_in_plan >= 0) {
      initiateLoading(duplicate ? "duplicate" : "save", false);
      setError({ type: "plan_name", message: "Add at least one nutrient.", idx: _empty_food_in_plan });
    } else {
      setError(false);
      const _mealplan = {
        category: category,
        name: name,
        description: description,
        image: image,
        plan: plan,
      };

      if (from === "coach" || !user.admin) {
        if (update) {
          _mealplan.last_updated = new Date();
          
          deleteMediaArrayFromStorage(deleteUrlArray, () => {
            updateMealplanCoach(user.id, _mealplan, props.location.state.item.id, (result) => {
              if (result) {
                if (duplicate) {
                  _mealplan.image = "";
                  props.history.push("/mealplan", { update: false, copy: true, from: from, item: _mealplan });
                } else {
                  props.history.push("/mealplans");
                }
              } else {
                initiateLoading(duplicate ? "duplicate" : "save", false);
                setError({ type: "default", message: "An unexpected error occurred while updating this workout." });
              }
            });
          });
        } else {
          _mealplan.created = new Date();
          deleteMediaArrayFromStorage(deleteUrlArray, () => {
            addMealplanCoach(user.id, _mealplan, (result) => {
              if (result) {
                if (duplicate) {
                  _mealplan.image = "";
                  props.history.push("/mealplan", { update: false, copy: true, from: from, item: _mealplan });
                } else {
                  props.history.push("/mealplans");
                }
              } else {
                initiateLoading(duplicate ? "duplicate" : "save", false);
                setError({ type: "default", message: "An unexpected error occurred while adding this workout." });
              }
            });
          });
        }
      } else {
        if (update) {
          _mealplan.last_updated = new Date();
          
          deleteMediaArrayFromStorage(deleteUrlArray, () => {
            updateMealplanAurum(_mealplan, props.location.state.item.id, (result) => {
              if (result) {
                if (duplicate) {
                  _mealplan.image = "";
                  props.history.push("/mealplan", { update: false, copy: true, from: from, item: _mealplan });
                } else {
                  props.history.push("/mealplans");
                }
              } else {
                initiateLoading(duplicate ? "duplicate" : "save", false);
                setError({ type: "default", message: "An unexpected error occurred while updating this workout." });
              }
            });
          });
        }else if(props.location.state.copy){
          deleteMediaArrayFromStorage(deleteUrlArray, () => {
            addMealplanCoach(user.id, _mealplan, (result) => {
              if (result) {
                if (duplicate) {
                  _mealplan.image = "";
                  props.history.push("/mealplan", { update: false, copy: true, from: from, item: _mealplan });
                } else {
                  props.history.push("/mealplans");
                }
              } else {
                initiateLoading(duplicate ? "duplicate" : "save", false);
                setError({ type: "default", message: "An unexpected error occurred while adding this workout." });
              }
            });
          });
        } 
        else {
          _mealplan.created = new Date();
          deleteMediaArrayFromStorage(deleteUrlArray, () => {
            addMealplanAurum(_mealplan, (result) => {
              if (result) {
                if (duplicate) {
                  _mealplan.image = "";
                  props.history.push("/mealplan", { update: false, copy: true, from: from, item: _mealplan });
                } else {
                  props.history.push("/mealplans");
                }
              } else {
                initiateLoading(duplicate ? "duplicate" : "save", false);
                setError({ type: "default", message: "An unexpected error occurred while adding this workout." });
              }
            });
          });
        }
      }
    }
  }
  console.log("user.admin",user.admin,"isAdmin",isAdmin,"from",from,"user",user)
  function copyToCoach() {
    const item = {
      category: category,
      name: name,
      description: description,
      image: "",
      plan: plan,
    };
    props.history.push("/mealplan", { update: false, copy: true, from: from, item });
  }

  return (
    <div className="c-page-wrapper" style={{flexFlow: 'column'}}>
      <Header title={update ? "Update Nutrition" : props.location.state.copy?"Copy to trainer account":"New Mealplan"} subtitle={true} />
      <div className="c-page-main c-define-page c-page-details">
        <div className="c-add-workout-header">
          <div className="c-image">
            <h3 className="c-upload-banner">Banner</h3>
            <DefineMedia isAdmin={isAdmin} error={error && error.type === "image" ? error.message : false} errorStyles={{ width: "310px" }} media={image} pageType={"image"} storageUrl={`${from === "coach" ? "coach/" + user.id : "aurum"}/mealplans/`} onMediaChange={(e) => setImage(e)} addToDeleteUrl={addToDeleteUrl} />
            {isAdmin && <p className="c-pixels">800 x 800 pixels</p>}
          </div>
          <div className="c-header-input">
            {isAdmin ? (
              <>
                <Input placeholder="Full name of mealplan" label="Title" value={name} onChange={(e) => setName(e)} error={error && error.type === "name" ? error.message : false} />
                <Input placeholder="Short description of the mealplan" label="Description" title="Description" value={description} onChange={(e) => setDescription(e)} error={error && error.type === "description" ? error.message : false}/>
              </>
            ) : (
              <div className="c-no-admin-workout-header">
                <div className="c-no-admin-input-replace">
                  <span>Name</span>
                  <p>{name}</p>
                </div>
                <div className="c-no-admin-input-replace">
                  <span>Description</span>
                  <p>{description}</p>
                </div>
              </div>
            )}
          </div>
        </div>

        <div class="table-calories"> 
          <h2>Total Calories : { Math.round(totalCalories.calories*100)/100 }</h2>
          <table bgcolor="#FFF" width="100%" align="left" cellspacing="10">
            <tr align="left">
              <th width="20%">Protein</th>
              <th width="20%">Fat</th>
              <th width="20%">Carbohydrates</th>
              <th width="20%">Alcohol</th>
              <th width="20%">Fiber</th>
            </tr>
            <tr>
              <td>{ Math.round(totalCalories.protein*100)/100 }</td>
              <td>{ Math.round(totalCalories.fats*100)/100 }</td>
              <td>{ Math.round(totalCalories.carbs*100)/100 }</td>
              <td>{ Math.round(totalCalories.alcohol*100)/100 }</td>
              <td>{ Math.round(totalCalories.fiber*100)/100 }</td>
            </tr>
          </table>
        </div>


        <Plans isAdmin={isAdmin} addFood={(idx) => addFood(idx)} plan={plan} set_plan={set_plan} onDragEnd={onDragEnd} removeSet={(e) => setShowPopup({ type: "set", id: e })} removeExercise={(mealplan_idx, set_idx) => setShowPopup({ type: "mealplan", mealplan_idx: mealplan_idx, set_idx: set_idx })} onChange={(e, type, food_idx, plan_idx) => onChange(e, type, food_idx, plan_idx)} error={error} />

        {isAdmin && (
          <>
            <button className="c-add-content-btn" style={{backgroundColor: '#2F727C'}} onClick={() => addSet()}>
              Add Meal
            </button>
            {error && <p className="c-default-error-message">{error.message}</p>}
            <div className="c-button-collection" style={{alignItems: "center"}}>
              <Button text="Save" color="#fff" backgroundColor="#00BDA5" onSubmit={() => onSubmit(false)} loading={loading} />
              {/* <Button text="Save and add another" color="#fff" backgroundColor="#00BDA5" onSubmit={() => onSubmit(true)} loading={loadingDuplicate} /> */}
              <p className="c-cancel-button" onClick={() => window.history.back()}>Cancel</p>
            </div>
          </>
        )}
        {/* comented copt btn */}
        {/* {(from === "aurum" || from=="coach") && !user.admin && props.location.state.update && (
          <div className="c-copy-workout-btn">
            <Button text="Copy workout" color="#fff" backgroundColor="#00BDA5" onSubmit={() => copyToCoach()} loading={loading} />
          </div>
        )} */}
      </div>
      {showPopup && (
        <Popup
          title={"Remove set"}
          button="Remove"
          deletePopup={true}
          description={"Are you sure you want to remove this set? This can not be undone."}
          onAction={() => removeSet(showPopup.id)}
          onCancel={() => {
            setShowPopup(false);
          }}
        />
      )}
    </div>
  );
}

export default DefineMealplan;
